<form class="filter-shell" [formGroup]="filterForm" (submit)="submitFilters($event)">
  <section class="filter-accordion">
    <button type="button" class="filter-accordion-header" (click)="toggleFiltersVisibility()"
      [attr.aria-expanded]="isFiltersExpanded" aria-controls="esteira-filter-body">
      <span class="filter-accordion-title">Filtros</span>
      <span class="filter-accordion-toggle-label">{{ isFiltersExpanded ? 'ocultar' : 'mostrar' }}</span>
    </button>

    <div class="filter-accordion-body" id="esteira-filter-body" *ngIf="isFiltersExpanded">
      <section class="filter-panel">

        <div class="search-row">
          <label class="field-label" for="esteira-search">Buscar</label>
          <div class="search-box">
            <input id="esteira-search" type="text" formControlName="searchText"
              placeholder="Buscar por contrato, proposta, banco, nome parceiro, status, canal, tipo, cliente ou CPF/CNPJ" />
          </div>
        </div>

        <div class="contexts-grid">
          <article class="filter-context filter-context-invoice" [class.filter-context-active]="isInvoiceContext()"
            [class.filter-context-disabled]="!isInvoiceContext()" role="button" tabindex="0"
            (click)="setContext('invoice')" (keydown.enter)="setContext('invoice')" (keydown.space)="setContext('invoice')">
            <div class="context-header">
              <div class="context-title">
                <strong>Faturamento</strong>
              </div>
              <span class="context-badge" [class.context-badge-hidden]="!isInvoiceContext()">Ativo</span>
            </div>

            <div class="context-body">
              <div class="filter-grid">
                <!-- <div class="field">
              <label class="field-label">Fases</label>
              <div class="combo-wrap" (appOutsideClick)="closeDropdown()" (click)="$event.stopPropagation()">
                <button
                  class="combo-trigger"
                  type="button"
                  (click)="toggleDropdown($event, 'stages', 'invoice')">
                  <span>{{ getStageTriggerText() }}</span>
                  <span class="combo-arrow">&#9660;</span>
                </button>

                <div class="combo-dropdown" *ngIf="openDropdown === 'stages'" (click)="$event.stopPropagation()">
                  <label class="combo-option" *ngFor="let stage of stageOptions">
                    <input
                      type="checkbox"
                      [checked]="isStageSelected(stage)"
                      (change)="toggleStage(stage, $any($event.target).checked)" />
                    <span>{{ stage }}</span>
                  </label>
                </div>
              </div>
            </div> -->

                <div class="field">
                  <label class="field-label" for="esteira-status-lote-invoice-trigger">Status lote</label>
                  <div class="combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()" (click)="$event.stopPropagation()">
                    <button id="esteira-status-lote-invoice-trigger" class="combo-trigger" type="button" [disabled]="!isInvoiceContext()"
                      (click)="toggleDropdown($event, 'statuses', 'invoice')">
                      <span>{{ getStatusTriggerText() }}</span>
                      <span class="combo-arrow">&#9660;</span>
                    </button>

                    <div class="combo-dropdown" role="presentation" *ngIf="openDropdown === 'statuses'" (click)="$event.stopPropagation()">
                      <label class="combo-option" *ngFor="let status of statusOptions">
                        <input type="checkbox" [checked]="isStatusSelected(status.label)"
                          (change)="toggleStatus(status.label, $any($event.target).checked)" />
                        <span>{{ status.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="field-label" for="esteira-contratos-invoice-select">Contratos</label>
                  <div class="combo-wrap" role="presentation" (click)="$event.stopPropagation()">
                    <select id="esteira-contratos-invoice-select" class="combo-select" [disabled]="!isInvoiceContext()"
                      [value]="filterForm.controls.contractMode.value"
                      (change)="setContractMode($any($event.target).value)">
                      <option *ngFor="let option of contractModes" [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="field">
                  <label class="field-label" for="esteira-aliquotas-invoice-select">Aliquotas</label>
                  <div class="combo-wrap" role="presentation" (click)="$event.stopPropagation()">
                    <select id="esteira-aliquotas-invoice-select" class="combo-select" [disabled]="!isInvoiceContext()"
                      [value]="filterForm.controls.rateMode.value" (change)="setRateMode($any($event.target).value)">
                      <option *ngFor="let option of rateModes" [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </article>

          <article class="filter-context filter-context-transfer" [class.filter-context-active]="!isInvoiceContext()"
            [class.filter-context-disabled]="isInvoiceContext()" role="button" tabindex="0"
            (click)="setContext('transfer')" (keydown.enter)="setContext('transfer')" (keydown.space)="setContext('transfer')">
            <div class="context-header">
              <div class="context-title">
                <strong>Repasse</strong>
                <!-- <span>Contratos em lotes de repasse</span> -->
              </div>
              <span class="context-badge" [class.context-badge-hidden]="isInvoiceContext()">Ativo</span>
            </div>

            <div class="context-body">
              <div class="filter-grid filter-grid-transfer">
                <div class="field">
                  <label class="field-label" for="esteira-status-lote-transfer-trigger">Status lote</label>
                  <div class="combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()" (click)="$event.stopPropagation()">
                    <button id="esteira-status-lote-transfer-trigger" class="combo-trigger" type="button" [disabled]="isInvoiceContext()"
                      (click)="toggleDropdown($event, 'transferStatuses', 'transfer')">
                      <span>{{ getTransferStatusTriggerText() }}</span>
                      <span class="combo-arrow">&#9660;</span>
                    </button>

                    <div class="combo-dropdown" role="presentation" *ngIf="openDropdown === 'transferStatuses'"
                      (click)="$event.stopPropagation()">
                      <label class="combo-option" *ngFor="let status of transferStatusOptions">
                        <input type="checkbox" [checked]="isTransferStatusSelected(status)"
                          (change)="toggleTransferStatus(status, $any($event.target).checked)" />
                        <span>{{ status }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="field-label" for="esteira-contratos-transfer-select">Contratos</label>
                  <div class="combo-wrap" role="presentation" (click)="$event.stopPropagation()">
                    <select id="esteira-contratos-transfer-select" class="combo-select" [disabled]="isInvoiceContext()"
                      [value]="filterForm.controls.transferContractMode.value"
                      (change)="setTransferContractMode($any($event.target).value)">
                      <option *ngFor="let option of contractModes" [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
               

                <div class="field">
                  <label class="field-label" for="esteira-aliquotas-transfer-select">Aliquotas</label>
                  <div class="combo-wrap" role="presentation" (click)="$event.stopPropagation()">
                    <select id="esteira-aliquotas-transfer-select" class="combo-select" [disabled]="isInvoiceContext()"
                      [value]="filterForm.controls.transferRateMode.value"
                      (change)="setTransferRateMode($any($event.target).value)">
                      <option *ngFor="let option of rateModes" [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>

                
                <div class="field">
                  <label class="field-label" for="esteira-status-omie-transfer-trigger">Status do OMIE</label>
                  <div class="combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()" (click)="$event.stopPropagation()">
                    <button id="esteira-status-omie-transfer-trigger" class="combo-trigger" type="button" [disabled]="isInvoiceContext()"
                      (click)="toggleDropdown($event, 'orderStatuses', 'transfer')">
                      <span>{{ getOrderStatusTriggerText() }}</span>
                      <span class="combo-arrow">&#9660;</span>
                    </button>

                    <div class="combo-dropdown" role="presentation" *ngIf="openDropdown === 'orderStatuses'"
                      (click)="$event.stopPropagation()">
                      <label class="combo-option" *ngFor="let status of orderStatusOptions">
                        <input type="checkbox" [checked]="isOrderStatusSelected(status)"
                          (change)="toggleOrderStatus(status, $any($event.target).checked)" />
                        <span>{{ status }}</span>
                      </label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </article>
        </div>

        <div class="actions-row">
          <div class="buttons-row">
            <button type="button" class="ui-btn ui-btn--secondary" (click)="clearFilters()">
              Limpar filtros
            </button>
            <button type="submit" class="ui-btn ui-btn--primary">
              Buscar
            </button>
          </div>
        </div>

      </section>
    </div>
  </section>
</form>